import { richTextResolver } from "@website-builder/utilities-index";

export default (
	{ title, content },
	{ story: { shortName, programName }, globalVariableWithURL = [] },
) => {
	const contentInHtml = richTextResolver(content, globalVariableWithURL);

	return {
		title,
		contentInHtml,
		shortName: shortName && shortName.trim(),
		programName,
	};
};
